import React, { useState } from "react";
import { Form, Spinner } from 'react-bootstrap';
import useModal from "../UseModal";

export default function AutoSelectInput({ className = "", initial, update, placeholder, options, confirm }) {
    const [value, setValue] = useState(initial ?? "");
    const [pending, setPending] = useState(false);
    const { ModalDialog, showConfirm } = useModal();

    async function onChange(e) {
        setValue(e.target.value);

        if (confirm && !await showConfirm(...confirm(e.target.value || placeholder))) {
            setValue(value);
            return;
        }

        setPending(true);

        try {
            await update?.(e.target.value);
        } finally {
            setPending(false);
        }
    }

    return (
        <Form.Group className={`form-group flex flex-col w-full position-relative ${className}`}>
            {ModalDialog}
            <Form.Select className={`text-lg rounded-sm border-neutral-300 border-b-neutral-200 inset-shadow-sm inset-shadow-neutral-200`} value={value} onChange={onChange} disabled={pending} style={pending ? { backgroundImage: "none" } : {}}>
                {placeholder && <option value="">{placeholder}</option>}
                {options.map(o => <option key={o} value={o}>{o}</option>)}
            </Form.Select>
            {pending && <Spinner animation="border" className="inline-spinner position-absolute" />}
        </Form.Group>
    );
}